var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-2 station-search-row-note"},[_c('i',{class:['far', _vm.icon, 'fa-fw']}),_vm._v(" "),_c('span',{staticClass:"highlight"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }